'use client';

import { Paginator } from '@dealerportal/catalog-ui/Modules/Paginations/Paginator';
import { useRouter } from 'next/navigation';
import type { ComponentPropsWithoutRef } from 'react';

type Props = Omit<
  ComponentPropsWithoutRef<typeof Paginator>,
  'onPageChange'
> & {
  blogSlug: string;
};

const transformTemplate = (templateString: string, selectedPage: number) => {
  const placeholderRegex = /{page}/g;
  const transformedString = templateString.replace(
    placeholderRegex,
    selectedPage.toString()
  );

  return transformedString;
};

export const BlogPaginator = (props: Props) => {
  const router = useRouter();
  const hrefTemplate = `/${props.blogSlug}/{page}`;

  return (
    <Paginator
      {...props}
      hrefBuilder={(selectedPage) =>
        transformTemplate(hrefTemplate, selectedPage)
      }
      onPageChange={({ selected }) => {
        router.push(transformTemplate(hrefTemplate, selected + 1));
      }}
    />
  );
};
